export default __webpack_public_path__ + "assets/icon-redo.ef160507.webp";